<!-- <main class="page-main"> -->
@if (index0) {
  <div class="layout layout--login">
    <div class="layout__login">
      <div class="layout__login-inner">
        <div class="card card--login">
          <div class="card__heading">
            <div class="card__avatar">
              <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <h3>{{index0?.header}}</h3>
          </div>
          <div class="card-body">
            <div class="card__form">
              <p [innerHTML]="index0?.body"></p>
            </div>
            <div class="card__btn">
              @if (index0?.buttons?.length) {
                <a href="javascript:;" [routerLink]="'/'+index0?.buttons[0]?.url" class="button button--lg button--primary">{{index0?.buttons[0].button_text}}</a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
<div class="container-fluid layout layout--choose">
  <div class="layout__main">
    <h2 class="font-semibold mt-lg-30 mb-20">{{tiers?.length === 1 ? "Here's your plan" : pageInfo?.page_header}}</h2>

    <!-- A single tier (real or the synthetic one for tier-less groups) has nothing to switch between -->
    @if ((tiers?.length ?? 0) > 1) {
      <div class="plan-level mb-20" [attr.data-num-plans]="tiers?.length">
        <div class="plan-level__inner">
          <!-- hidden inputs with linked labels -->
          @for (tier of tiers; track tier; let i = $index) {
            <input type="radio" [attr.checked]="tier?.tier_id === selectedTier?.tier_id ? 'checked' : null"
              name="plan-levels" id="plan-level-{{tier?.tier_id}}"
              class="plan-level__input" />
          }

          <div class="plan-level__indi"></div>

          <div class="plan-level__items">
            @for (tier of tiers; track tier; let i = $index) {
              <label class="plan-level__item " (click)="setSelectedTier(tier)"
                [ngClass]="{'is-recommended': tier?.recommended === 1, 'is-active': tier?.tier_id === selectedTier?.tier_id}"
                for="plan-level-{{tier?.tier_id}}">
                <div class="plan-level__label">{{tier?.tier_name}}</div>
                <div class="plan-level__description">
                  <small>{{tier?.tier_label}}</small>
                </div>
              </label>
            }

          </div>
        </div>
      </div>
    }

    @if (checksState === 'running') {
      <p class="mb-20" role="status"><small>Checking your cover and eligibility&hellip;</small></p>
    } @else if (checksState === 'error') {
      <p class="mb-20" role="alert"><small>We couldn't finish checking your quote. <a href="#" (click)="retryChecks(); $event.preventDefault()"><strong>Try again</strong></a></small></p>
    }

    <p class="mb-40">@if (tierRefine; as refine) {<ng-container>{{refine.before}}@if (refine.name) {<strong>{{refine.name}}</strong>}{{refine.after}} </ng-container>}<a href="#filters-modal"
      data-toggle="modal" data-backdrop="static"><strong>Tap here to refine your
    options</strong></a></p>

    <!-- Single product view when only 1 product -->
    @if (selectedProducts?.length === 1) {
      <div style="min-height: 600px;">
        @if (selectedProducts[0]; as product) {
          <div class="choose-single">
            <div class="choose-single__header">
              <div class="choose-single__header-company" (click)="openRatingSidesheet(product, $event)" style="cursor: pointer;">
                <div class="choose-single__header-company-thumb">
                  <img [src]="product?.img_path" class="img-fluid" [alt]="product?.product_name" />
                </div>
                <div class="choose-single__header-company-rating">
                  <div class="stars-compact">
                    <div class="stars-compact__star">
                      <svg class="icon">
                        <use xlink:href="#star"></use>
                      </svg>
                    </div>
                    <div class="stars-compact__num">{{ getOverallRating(product?.insurer_rating) || 5 }}</div>
                  </div>
                </div>
              </div>
              <div class="choose-single__header-title">
                <h5>{{product?.product_name}}</h5>
                @if (product?.recommended === 1) {
                  <img src="assets/icn/exclusive.svg" alt="Exclusive" class="icon">
                }
              </div>
              <div class="choose-single__header-price">
                <div class="choose-single__header-price-main">
                  @if (isPriceRefreshing(product)) {
                    <div class="loading-skeleton-price loading-skeleton-price--lg" role="status" aria-label="Updating price"></div>
                  } @else if (hasCardError(product)) {
                    <p class="price price--sm"><small>Couldn't refresh this price. <a href="#" (click)="retryCard(product.product_id); $event.preventDefault()"><strong>Retry</strong></a></small></p>
                  } @else {
                    <p class="price price--lg"><strong><em>{{product?.premium}}</em>.00</strong> /{{product?.frequency_short}}</p>
                  }
                </div>
                @if (product?.addons_premium && !isPriceRefreshing(product) && !hasCardError(product)) {
                  <div class="choose-single__header-price-benefits">
                    <p><small>Including {{product?.addons_premium}} in <a href="#" (click)="openBenefitsSidesheet(product, $event)"
                      class="font-underline"><strong>added benefits</strong></a></small></p>
                    </div>
                  }
                  <div class="choose-single__header-price-breakdown">
                    <a href="#" (click)="openBreakdownSidesheet(product, $event)"><strong>See breakdown</strong></a>
                  </div>
                </div>              
              </div>
              <div class="choose-single__cta">
                <a href="javascript:void(0)" (click)="onChooseClick(product, $event)" [class.button--disabled]="!canChoose(product) || choosingProductId !== null" [class.button--loading]="choosingProductId === product.product_id"
                class="button button--lg button--block-xs"
                [ngClass]="{'button--primary': isChosen(product), 'button--secondary': !isChosen(product)}">
                @if (choosingProductId === product.product_id) {<span class="button__spinner"><span class="spinner"></span></span>}
                {{isChosen(product) ? 'Finalise and pay' : 'Choose and pay'}}</a>
                <a href="javascript:void(0)" (click)="chat?.toggle()" class="button button--lg button--secondary button--block-xs">
                  <svg class="icon">
                    <use xlink:href="#mobile-call"></use>
                  </svg>
                  Chat to an agent
                </a>
              </div>
              <div class="choose-single__data">
                @if (product?.features?.length) {
                <div class="choose-single__features">
                  <h5 class="font-16 mb-10">
                    Features
                    @if (sectionTooltips['features']) {
                      <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                        data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['features']">
                        <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                      </a>
                    }
                  </h5>
                  <ul class="list-unstyled">
                    @for (feature of product.features; track feature) {
                      <li>
                        <div class="choose-single__features-lhs">
                          <p>
                            {{feature?.label}}
                            @if (feature?.tooltip) {
                              <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                data-toggle="popover" data-trigger="focus"
                                [attr.data-content]="feature?.tooltip">
                                <svg class="icon icon--sm">
                                  <use xlink:href="#info-solid"></use>
                                </svg>
                              </a>
                            }
                          </p>
                          @if (feature?.side_sheet_url) {
                            <a href="#" (click)="openExcessesSidesheet(product, $event)"
                              class="font-underline"><strong>Adjust excesses</strong></a>
                            }
                          </div>
                          @if (feature?.value) {
                            <div class="choose-single__features-rhs">
                              <p><small><strong>{{feature?.value}}</strong></small></p>
                            </div>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                }
                  <div class="choose-single__benefits">
                    @if (product?.benefits?.length) {
                    <div class="choose-single__benefits-col">
                      <h6>
                        Included
                        @if (sectionTooltips['included']) {
                          <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                            data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['included']">
                            <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                          </a>
                        }
                      </h6>
                      <ul class="list-unstyled">
                        @for (benefit of product.benefits; track benefit) {
                          <li>
                            <div class="choose-single__benefits-icn">
                              <img class="icon icon--md" [src]="benefit?.img_path" alt="" />
                            </div>
                            <div class="choose-single__benefits-copy">
                              <div class="choose-single__benefits-lhs">
                                <p>
                                  <small>{{benefit?.vaps_name}}</small>
                                  @if (benefit?.tooltip) {
                                    <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                      data-toggle="popover" data-trigger="focus" [attr.data-content]="benefit?.tooltip">
                                      <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                                    </a>
                                  }
                                </p>
                              </div>
                              @if (benefit?.limit) {
                                <div class="choose-single__benefits-rhs">
                                  @if (benefit?.limit === '-') {
                                    <svg class="icon text-color-personal"><use xlink:href="#circle-small-included"></use></svg>
                                  } @else {
                                    <p><small><strong>{{benefit?.limit}}</strong></small></p>
                                  }
                                </div>
                              }
                            </div>
                          </li>
                        }
                      </ul>
                    </div>
                    }
                    @if (product?.not_included?.length) {
                      <div class="choose-single__benefits-col">
                        <h6>
                        Not included
                        @if (sectionTooltips['not_included']) {
                          <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                            data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['not_included']">
                            <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                          </a>
                        }
                      </h6>
                        <ul class="list-unstyled">
                          @for (item of product.not_included; track item.entity_type + '-' + item.entity_id) {
                            <li>
                              <div class="choose-single__benefits-icn">
                                <img class="icon icon--md" [src]="item?.img_path || 'assets/icn/24px-generic.svg'" alt="" (error)="onIconError($event)" />
                              </div>
                              <div class="choose-single__benefits-copy">
                                <div class="choose-single__benefits-lhs">
                                  <p><small>{{item?.name}}</small></p>
                                </div>
                              </div>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                </div>
                <div class="choose-single__tray">
                  <div class="choose-single__tray-price">
                    @if (isPriceRefreshing(product)) {
                      <div class="loading-skeleton-price loading-skeleton-price--lg" role="status" aria-label="Updating price"></div>
                    } @else if (hasCardError(product)) {
                      <p class="price price--sm"><small>Couldn't refresh this price. <a href="#" (click)="retryCard(product.product_id); $event.preventDefault()"><strong>Retry</strong></a></small></p>
                    } @else {
                      <p class="price price--lg"><strong><em>{{product?.premium}}</em>.00</strong> /{{product?.frequency_short}}</p>
                    }
                    @if (product?.addons_premium && !isPriceRefreshing(product) && !hasCardError(product)) {
                      <div class="choose-single__tray-price-benefits">
                        <p><small>Including {{product?.addons_premium}} in <a href="#" (click)="openBenefitsSidesheet(product, $event)"
                          class="font-underline" tabindex="0"><strong>added benefits</strong></a></small></p>
                        </div>
                      }
                      <div class="choose-single__tray-price-breakdown">
                        <a href="#" (click)="openBreakdownSidesheet(product, $event)"><strong>See breakdown</strong></a>
                      </div>
                    </div>
                    <div class="choose-single__tray-cta">
                      <a href="javascript:void(0)" (click)="chat?.toggle()" class="button button--lg button--secondary">
                        <svg class="icon">
                          <use xlink:href="#mobile-call"></use>
                        </svg>
                      Chat to an agent</a>
                      <a href="javascript:void(0)" (click)="onChooseClick(product, $event)" [class.button--disabled]="!canChoose(product) || choosingProductId !== null" [class.button--loading]="choosingProductId === product.product_id" class="button button--lg"
                        [ngClass]="{'button--primary': isChosen(product), 'button--secondary': !isChosen(product)}">
                      @if (choosingProductId === product.product_id) {<span class="button__spinner"><span class="spinner"></span></span>}
                {{isChosen(product) ? 'Finalise and pay' : 'Choose and pay'}}</a>
                    </div>
                  </div>
                <div class="choose-single__docs">
                  <div class="choose-single__actions">
                    <ul class="list-unstyled">
                      @if (product?.has_covers) {
                        <li>
                          <div class="choose-single__actions-icn">
                            <img class="icon icon--md" src="assets/icn/products/policy-benefits.svg" alt="" />
                          </div>
                          <div class="choose-single__actions-copy">
                            <p><strong><small>What’s Covered and Not Covered</small></strong></p>
                          </div>
                          <div class="choose-single__actions-link">
                            <p><a href="javascript:void(0)" (click)="openCoversModal(product, $event)">View</a></p>
                          </div>
                        </li>
                      }
                      <li>
                        <div class="choose-single__actions-icn">
                          <img class="icon icon--md" src="assets/icn/products/quote.svg" alt="" />
                        </div>
                        <div class="choose-single__actions-copy">
                          <p><strong><small>Quote Schedule</small></strong></p>
                        </div>
                        <div class="choose-single__actions-link">
                          <p><a href="javascript:void(0)" (click)="viewQuoteSchedule(product)">View</a></p>
                        </div>
                      </li>
                      @if (product?.has_wording) {
                        <li>
                          <div class="choose-single__actions-icn">
                            <img class="icon icon--md" src="assets/icn/products/policy-benefits.svg" alt="" />
                          </div>
                          <div class="choose-single__actions-copy">
                            <p><strong><small>Policy Wording</small></strong></p>
                          </div>
                          <div class="choose-single__actions-link">
                            <p><a href="javascript:void(0)" (click)="viewPolicyWording(product)">View</a></p>
                          </div>
                        </li>
                      }
                      <!-- <li>
                        <div class="choose-single__actions-icn">
                          <img class="icon icon--md" src="assets/icn/products/professional-indemnity-run-off.svg" alt="" />
                        </div>
                        <div class="choose-single__actions-copy">
                          <p><strong><small>Product brochure</small></strong></p>
                        </div>
                        <div class="choose-single__actions-link">
                          <p><a href="/pages/everything.docs-policy-wording-view.html" target="_blank">Download</a></p>
                        </div>
                      </li> -->
                    </ul>
                  </div>
                </div>
                </div>
              }
            </div>
          }

          <!-- Slider view for multiple products -->
          @if (selectedProducts?.length > 1) {
            <div style="min-height: 900px;">
              <div class="choose-slider" id="choose-slider"
                [style.visibility]="isSliderReady ? 'visible' : 'hidden'">
                @for (product of selectedProducts; track product; let i = $index) {
                  <div class="choose-slider__slide" [ngClass]="{'is-recommended': product?.recommended === 1}">
                    <div class="choose-slider__slide-inner">
                      <div class="choose-slider__content">
                        @if (product?.recommended === 1) {
                          <div class="choose-slider__note" id="demo-note">
                            <small>Recommended</small>
                          </div>
                        }
                        <div class="choose-slider__header">
                          <div class="choose-slider__header-company" (click)="openRatingSidesheet(product, $event)" style="cursor: pointer;">
                            <div class="choose-slider__header-company-thumb">
                              <img src="{{product?.img_path}}" class="img-fluid" alt="{{product?.product_name}}" />
                            </div>
                            <div class="choose-slider__header-company-rating">
                              <div class="stars-compact">
                                <div class="stars-compact__star">
                                  <svg class="icon">
                                    <use xlink:href="#star"></use>
                                  </svg>
                                </div>
                                <div class="stars-compact__num">{{ getOverallRating(product?.insurer_rating) || 0 }}</div>
                              </div>
                            </div>
                          </div>
                          <div class="choose-slider__header-title">
                            <h5 id="demo-title-update">{{product?.product_name}}</h5>
                            @if (product?.recommended === 1) {
                              <img src="assets/icn/exclusive.svg" alt="Exclusive" class="icon">
                            }
                          </div>
                          <div class="choose-slider__header-price">
                            <div class="choose-slider__header-price-main">
                              @if (isPriceRefreshing(product)) {                             
                                <div class="loading-skeleton-price loading-skeleton-price--lg" role="status" aria-label="Updating price"></div>
                              } @else if (hasCardError(product)) {
                                <p class="price price--sm"><small>Couldn't refresh this price. <a href="#" (click)="retryCard(product.product_id); $event.preventDefault()"><strong>Retry</strong></a></small></p>
                              } @else {
                                <p class="price price--lg" id="demo-price-update"><strong><em>{{product?.premium}}</em>.00</strong>
                              /{{product?.frequency_short}}</p>
                              }
                            </div>
                          @if (product?.addons_premium && !isPriceRefreshing(product) && !hasCardError(product)) {
                            <div class="choose-slider__header-price-benefits">
                              <p><small>Including {{product?.addons_premium}} in <a href="#" (click)="openBenefitsSidesheet(product, $event)"
                                class="font-underline"><strong>added
                              benefits</strong></a></small></p>
                            </div>
                          } @else if (anyAddonsPremium) {
                            <!-- Keeps this card the same height as a neighbour that shows the line, so Included / Not included start level -->
                            <div class="choose-slider__header-price-benefits" aria-hidden="true">
                              <p><small>&nbsp;</small></p>
                            </div>
                          }
                          <div class="choose-slider__header-price-breakdown">
                            <a href="#" (click)="openBreakdownSidesheet(product, $event)"><strong>See breakdown</strong></a>
                          </div>
                        </div>
                      </div>
                      <div class="choose-slider__cta">
                        <a href="javascript:void(0)" (click)="onChooseClick(product, $event)" [class.button--disabled]="!canChoose(product) || choosingProductId !== null" [class.button--loading]="choosingProductId === product.product_id"
                          class="button button--lg button--block-xs"
                          [ngClass]="{'button--primary': isChosen(product), 'button--secondary': !isChosen(product)}">
                        @if (choosingProductId === product.product_id) {<span class="button__spinner"><span class="spinner"></span></span>}
                {{isChosen(product) ? 'Finalise and pay' : 'Choose and pay'}}</a>
                      </div>
                      @if (product?.features?.length) {
                      <div class="choose-slider__features">
                        <h5 class="font-16 mb-10">
                    Features
                    @if (sectionTooltips['features']) {
                      <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                        data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['features']">
                        <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                      </a>
                    }
                  </h5>
                        <ul class="list-unstyled" [style.--min-items]="maxFeatureItems">
                          @for (feature of product.features; track feature) {
                            <li>
                              <div class="choose-slider__features-lhs">
                                <p>
                                  {{feature?.label}}
                                  @if (feature?.tooltip) {
                                    <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                      data-toggle="popover" data-trigger="focus"
                                      [attr.data-content]="feature?.tooltip">
                                      <svg class="icon icon--sm">
                                        <use xlink:href="#info-solid"></use>
                                      </svg>
                                    </a>
                                  }
                                </p>
                                @if (feature?.side_sheet_url) {
                                  <a href="#" (click)="openExcessesSidesheet(product, $event)"
                                    class="font-underline" tabindex="-1"><strong>Adjust
                                  excesses</strong></a>
                                }
                              </div>
                              @if (feature?.value) {
                                <div class="choose-slider__features-rhs">
                                  <p><small><strong>{{feature?.value}}</strong></small></p>
                                </div>
                              }
                            </li>
                          }
                        </ul>
                      </div>
                      }
                    </div>
                    @if (product?.show_compare !== 0) {
                    <div class="choose-slider__compare">
                      <label class="selection selection--reversed">
                        <input type="checkbox" name="quote-compare" [checked]="isCompared(product)"
                          [disabled]="compareDisabled(product)" (change)="toggleCompare(product)" />
                        <div class="selection__inner">
                          <div class="selection__main">
                            <div class="selection__content">
                              <div class="selection__indi"><span></span></div>
                              <div class="selection__label">
                                <div class="selection__title"><h6>Add to compare</h6></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                    }
                    <div class="choose-slider__btm">
                      @if (product?.benefits?.length) {
                      <div class="choose-slider__benefits">
                        <h6>
                        Included
                        @if (sectionTooltips['included']) {
                          <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                            data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['included']">
                            <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                          </a>
                        }
                      </h6>
                        <ul class="list-unstyled" [style.--min-items]="maxBenefitItems">
                          @for (benefit of product.benefits; track benefit) {
                            <li>
                              <div class="choose-slider__benefits-icn">
                                <img class="icon icon--md" src="{{benefit?.img_path}}" alt="" />
                              </div>
                              <div class="choose-slider__benefits-copy">
                                <div class="choose-slider__benefits-lhs">
                                  <p>
                                  <small>{{benefit?.vaps_name}}</small>
                                  @if (benefit?.tooltip) {
                                    <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                      data-toggle="popover" data-trigger="focus" [attr.data-content]="benefit?.tooltip">
                                      <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                                    </a>
                                  }
                                </p>
                                </div>
                                <div class="choose-slider__benefits-rhs">
                                  @if (benefit?.limit === '-') {
                                    <svg class="icon text-color-personal"><use xlink:href="#circle-small-included"></use></svg>
                                  } @else {
                                    <p><small><strong>{{benefit?.limit}}</strong></small></p>
                                  }
                                </div>
                              </div>
                            </li>
                          }
                        </ul>
                      </div>
                      }
                      @if (maxNotIncludedItems > 0 && product?.not_included?.length) {
                        <div class="choose-slider__benefits">
                          <h6 class="mt-30">
                        Not included
                        @if (sectionTooltips['not_included']) {
                          <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                            data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['not_included']">
                            <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                          </a>
                        }
                      </h6>
                          <ul class="list-unstyled" [style.--min-items]="maxNotIncludedItems">
                            @for (item of product.not_included; track item.entity_type + '-' + item.entity_id) {
                              <li>
                                <div class="choose-slider__benefits-icn">
                                  <img class="icon icon--md" [src]="item?.img_path || 'assets/icn/24px-generic.svg'" alt="" (error)="onIconError($event)" />
                                </div>
                                <div class="choose-slider__benefits-copy">
                                  <div class="choose-slider__benefits-lhs">
                                    <p><small>{{item?.name}}</small></p>
                                  </div>
                                </div>
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    </div>
                    <div class="choose-slider__docs">
                      <div class="choose-slider__actions">
                        <!-- TODO: min-items should be equal to the greatest number of items shown here amongst all visible cards once the list becomes dynamic -->
                        <ul class="list-unstyled" [style.--min-items]="maxActionLinks">
                          @if (product?.has_covers) {
                            <li>
                              <div class="choose-slider__actions-icn">
                                <img class="icon icon--md" src="assets/icn/products/policy-benefits.svg" alt="" />
                              </div>
                              <div class="choose-slider__actions-copy">
                                <p><strong><small>What’s Covered and Not Covered</small></strong></p>
                              </div>
                              <div class="choose-slider__actions-link">
                                <p><a href="javascript:void(0)" (click)="openCoversModal(product, $event)">View</a></p>
                              </div>
                            </li>
                          }
                          <li>
                            <div class="choose-slider__actions-icn">
                              <img class="icon icon--md" src="assets/icn/products/quote.svg" alt="" />
                            </div>
                            <div class="choose-slider__actions-copy">
                              <p><strong><small>Quote Schedule</small></strong></p>
                            </div>
                            <div class="choose-slider__actions-link">
                              <p><a href="javascript:void(0)" (click)="viewQuoteSchedule(product)">View</a></p>
                            </div>
                          </li>
                          @if (product?.has_wording) {
                            <li>
                              <div class="choose-slider__actions-icn">
                                <img class="icon icon--md" src="assets/icn/products/policy-benefits.svg" alt="" />
                              </div>
                              <div class="choose-slider__actions-copy">
                                <p><strong><small>Policy Wording</small></strong></p>
                              </div>
                              <div class="choose-slider__actions-link">
                                <p><a href="javascript:void(0)" (click)="viewPolicyWording(product)">View</a></p>
                              </div>
                            </li>
                          }
                          <!-- <li>
                            <div class="choose-slider__actions-icn">
                              <img class="icon icon--md" src="assets/icn/products/professional-indemnity-run-off.svg" alt="" />
                            </div>
                            <div class="choose-slider__actions-copy">
                              <p><strong><small>Product brochure</small></strong></p>
                            </div>
                            <div class="choose-slider__actions-link">
                              <p><a href="/pages/everything.docs-policy-wording-view.html" target="_blank">Download</a></p>
                            </div>
                          </li> -->
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <div class="row row--gap row--md mt-40 mb-20">
          <div class="col-xl-6">
            <div class="card card--help">
              <div class="card-body">
                <div class="card__thumb">
                  <img src="assets/img/help-create-quote.svg" class="img-fluid" />
                </div>
                <div class="card__content">
                  <h5>Found a better deal?</h5>
                  <p>Share your quote or policy schedule from a different insurer and we’ll try our best to get you a
                  better price.</p>
                </div>
                <div class="card__btn">
                  <a href="javascript:void(0)" (click)="emailUs()" class="button button--sm button--primary">Upload</a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-6">
            <div class="card card--help">
              <div class="card-body">
                <div class="card__thumb">
                  <img src="assets/img/help-chat-lady.svg" class="img-fluid" />
                </div>
                <div class="card__content">
                  <h5>Need help?</h5>
                  <p>Feel free to contact us via our online chatbot or call us directly if you would like help
                  completing your quote, or have any questions.</p>
                </div>
                <div class="card__btn">
                  <a href="javascript:void(0)" (click)="chat?.toggle()" class="button button--sm button--primary">Chat to us</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="layout__back">
        <button class="button button--back-alt d-md-none" title="Back" (click)="goBack()">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
        </button>
        <button class="link d-none d-md-flex" (click)="goBack()">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
          <small>Back to summary</small>
        </button>
      </div>
    </div>
}
  <!-- </main> -->
  <div class="modal modal--mini fade" id="filters-modal" tabindex="-1" role="dialog" aria-labelledby="filters-modal"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-mini">

        <div class="modal-mini__heading">
          <div class="container-fluid">
            <h4><span class="font-normal">Refine what you’re looking for in </span> <strong>{{selectedTier?.tier_name}}</strong></h4>
            <button class="modal-mini__heading-close" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </button>
          </div>
        </div>

        <div class="modal-mini__content">
          <div class="container-fluid">

            <div class="filter-group mb-10">

              @for (product of products; track product) {
                <label class="custom-input custom-input--checkbox custom-input--plan">
                  <input type="checkbox" (click)="setProduct(product)" name="checkbox-insurer-1" [checked]="isProductSelected(product)" />
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">
                    <span class="custom-input__label-company">
                      <img src="{{product?.img_path}}" alt="Santam" />
                    </span>
                    <span class="custom-input__label-text">
                      @if (product?.recommended === 1) {
                        <span class="tag-pill  tag-pill--everything-bg">
                          Recommended
                        </span>
                      }
                      <p>{{product?.product_name}}</p>
                    </span>
                    <span class="custom-input__label-price">
                      <p class="price price--sm"><strong>{{product?.premium}}</strong>/mo</p>
                    </span>
                  </span>
                </label>
              }

            </div>

          </div>
        </div>

        <div class="modal-mini__button">
          <div class="container-fluid">
            <a href="#" data-dismiss="modal" class="button button--block button--primary"
            id="filter-products-submit"  [class.disabled]="!filterTouched" [attr.disabled]="!filterTouched ? true : null">Show options</a>
          </div>
        </div>


      </div>
    </div>
  </div>
  <!-- Benefits Sidesheet Component -->
  <app-sidesheet
    #benefitsSidesheet
    sidesheetId="benefits-sidesheet"
    title="Added benefits"
    type="benefits"
    [data]="addedBenefits"
    [showBackButton]="true"
    [showEditButton]="false"
    [showTray]="true"
    [trayTotal]="selectedProduct?.premium"
    (closed)="onBenefitsSidesheetClosed()"
    (itemSelected)="onBenefitItemSelected($event)">
  </app-sidesheet>

  <!-- Breakdown Sidesheet Component -->
  <app-sidesheet
    #breakdownSidesheet
    sidesheetId="breakdown-sidesheet"
    type="insured-items"
    [data]="breakdownData"
    [showBackButton]="true"
    [showEditButton]="false"
    [showTray]="true"
    [trayTotal]="selectedProduct?.premium"
    (closed)="onBreakdownSidesheetClosed()">
  </app-sidesheet>

  <!-- Company Ratings Sidesheet Component -->
  <app-sidesheet
    #ratingSidesheet
    sidesheetId="company-ratings-sidesheet"
    [title]="selectedProduct?.product_name || 'Company Rating'"
    type="rating"
    [ratingData]="selectedProduct?.insurer_rating"
    [showBackButton]="true"
    [showEditButton]="false"
    [showTray]="true"
    (closed)="onRatingSidesheetClosed()">
  </app-sidesheet>

  <!-- Excesses Sidesheet Component -->
  <app-sidesheet
    #excessesSidesheet
    sidesheetId="excesses-sidesheet"
    [title]="'Excesses for ' + (selectedProduct?.product_name || '')"
    type="excesses"
    [data]="excessesData"
    [showBackButton]="true"
    [showEditButton]="false"
    [showTray]="true"
    [trayTotal]="selectedProduct?.premium"
    (closed)="onExcessesSidesheetClosed()"
    (excessChanged)="onExcessValueChanged($event)">
  </app-sidesheet>

  <!-- What's Covered and Not Covered Modal -->
  <div class="modal modal--max modal--wider fade fade-up" id="covered-modal" tabindex="-1" role="dialog" aria-labelledby="covered-modal-title" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content covered has-toggles">
        <header class="covered__header" id="covered-header">
          <div class="covered__header-title">
            <h4 id="covered-modal-title">What's Covered and Not Covered</h4>
          </div>
          <button type="button" class="covered__close" data-dismiss="modal" aria-label="Close">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </button>
          <div class="container-fluid">
            <div class="covered__option">
              <div class="covered__company">
                <div class="covered__company-thumb">
                  <img [src]="coversProduct?.img_path" class="img-fluid" [alt]="coversProduct?.product_name" />
                </div>
                <div class="covered__company-rating">
                  <div class="stars-compact">
                    <div class="stars-compact__star">
                      <svg class="icon"><use xlink:href="#star"></use></svg>
                    </div>
                    <div class="stars-compact__num">{{ getOverallRating(coversProduct?.insurer_rating) || 0 }}</div>
                  </div>
                </div>
              </div>
              <div class="covered__total-name">
                <h6>{{ coversProduct?.product_name }}</h6>
              </div>
            </div>
          </div>
          <nav class="tab-nav">
            <div class="container">
              <ul class="list-unstyled" id="covered-nav">
                @for (coverClass of coverClasses; track coverClass.class_id) {
                  <li [class.is-active]="coversActiveClass === coverClass.class_id">
                    <a href="javascript:void(0)" (click)="scrollToCoversClass(coverClass.class_id, $event)">{{ coverClass.class_name }}</a>
                  </li>
                }
              </ul>
            </div>
          </nav>
          <ul class="list-unstyled covered__tabs" id="covered-tabs">
            <li [class.is-active]="coversTab === 'covered'"><a href="#whats-covered" (click)="setCoversTab('covered', $event)">What's Covered</a></li>
            <li [class.is-active]="coversTab === 'not_covered'"><a href="#whats-not-covered" (click)="setCoversTab('not_covered', $event)">What's Not Covered</a></li>
          </ul>
        </header>
        <div class="covered__content" id="covered-content">
          <div class="covered__content-inner">
            <div class="covered__tab-content">
              <div class="covered__tab-pane is-active">
                <div class="covered-data">
                  @if (coversLoading) {
                    <div class="covered-data__title"><div class="container-fluid">Loading…</div></div>
                  } @else if (!coverClasses.length) {
                    <div class="covered-data__title"><div class="container-fluid">Nothing is listed for this product yet.</div></div>
                  }
                  @for (coverClass of coverClasses; track coverClass.class_id) {
                    <div class="covered-data__title" [id]="'covered-section-' + coverClass.class_id">
                      <div class="container-fluid">{{ coverClass.class_name }}</div>
                    </div>
                    <div class="covered-data__section">
                      @for (cover of coversFor(coverClass.class_id); track $index) {
                        <div class="covered-data__colhead">
                          @if (coversTab === 'covered') {
                            <svg class="icon text-color-personal"><use xlink:href="#circle-small-included"></use></svg>
                          } @else {
                            <svg class="icon text-color-error"><use xlink:href="#circle-small-excluded"></use></svg>
                          }
                          <div class="covered-data__colhead-icon">
                            <img src="assets/icn/products/benefit-generic.svg" class="icon icon--lg" alt="" />
                          </div>
                          <div class="covered-data__colhead-text">
                            <h4>{{ cover.cover_name }}</h4>
                            @if (cover.cover_description) {
                              <p>{{ cover.cover_description }}</p>
                            }
                            @if (cover.note) {
                              <p><small><strong>{{ cover.note }}</strong></small></p>
                            }
                          </div>
                        </div>
                      } @empty {
                        <div class="covered-data__colhead">
                          <div class="covered-data__colhead-text">
                            <p>Nothing listed here for this class.</p>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Important Things to Know Modal -->
  <div class="modal fade modal--mini" id="itk-modal" tabindex="-1" role="dialog" aria-labelledby="itk-modal"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-mini">
        <div class="modal-mini__heading">
          <div class="container-fluid">
            <h4>Important things to know</h4>
          </div>
        </div>

        <div class="modal-mini__content">
          <div class="container-fluid">
            <!-- can use accordion--sm modifier for smaller copy within the content area -->
            <div class="accordion accordion--gethelp" id="accordion-faqs">
              @if (quoteITKs?.sub_limits?.length) {
              <div class="accordion__item">
                <a href="#faq-1" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                  <div class="accordion__title-text">
                    <h5>Sub-limits</h5>
                  </div>
                  <div class="accordion__title-caret">
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </div>
                </a>
                <div class="accordion__body collapse" id="faq-1" data-parent="#accordion-faqs">
                  <div class="accordion__content">
                    @for (subLimit of quoteITKs?.sub_limits; track subLimit) {
                      <p [innerHTML]="subLimit?.sublimit_name">
                      </p>
                      <p [innerHTML]="subLimit?.sublimit_description">
                      </p>
                      <p [innerHTML]="subLimit?.sublimit_value">
                      </p>
                    }
                  </div>
                </div>
              </div>
              }
              <!-- /.accordion__item -->

              <div class="accordion__item">
                <a href="#faq-2" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                  <div class="accordion__title-text">
                    <h5>What's covered and what's not</h5>
                  </div>
                  <div class="accordion__title-caret">
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </div>
                </a>
                <div class="accordion__body collapse" id="faq-2" data-parent="#accordion-faqs">
                  <div class="accordion__content">
                    <p>

                    </p>
                    <ul>
                      @for (cover of quoteITKs?.cover; track cover) {
                        <li >
                          <strong>{{cover?.cover_name}}</strong><br>
                          {{cover?.cover_description}} - {{cover?.cover_value}}
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
              <!-- /.accordion__item -->

              <div class="accordion__item">
                <a href="#faq-3" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                  <div class="accordion__title-text">
                    <h5>Excesses</h5>
                  </div>
                  <div class="accordion__title-caret">
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </div>
                </a>
                <div class="accordion__body collapse" id="faq-3" data-parent="#accordion-faqs">
                  <div class="accordion__content">
                    <p>

                    </p>
                    @for (group of quoteITKs?.excess; track group) {
                      <h6>{{group.class_name}}</h6>
                      <ul>
                        @for (excess of group.items; track excess) {
                          <li>
                            <strong>{{excess?.description}}</strong> - {{excess?.excess}}
                          </li>
                        }
                      </ul>
                    }
                  </div>
                </div>
              </div>
              <!-- /.accordion__item -->
            </div>
          </div>
        </div>

        <div class="modal-mini__button">
          <div class="container-fluid">
            <a href="#" data-dismiss="modal" (click)="onContinue()" class="button button--primary">Continue</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /modal -->

  <!-- Compare tray: hidden until a card is ticked -->
  <footer class="question-tray question-tray--no-summary question-tray--compare" [class.is-inactive]="compareIds.length === 0">
    <div class="container">
      <div class="question-tray__alt-controls">
        <div class="question-tray__alt-compare">
          @for (slot of compareSlots; track $index) {
            @if (slot) {
              <div class="question-tray__compare-item">
                <div class="question-tray__compare-wrap">
                  <div class="question-tray__compare-company">
                    <img src="{{slot?.img_path}}" class="img-fluid" alt="{{slot?.product_name}}" />
                  </div>
                  <div class="question-tray__compare-title">{{slot?.product_name}}</div>
                  <div class="question-tray__compare-cost">
                    <p><strong>{{slot?.premium}}</strong> /{{slot?.frequency_short}}</p>
                  </div>
                </div>
                <button type="button" class="question-tray__compare-close" aria-label="Remove from compare" (click)="removeCompare(slot.product_id)">
                  <svg class="icon"><use xlink:href="#close-circle-small"></use></svg>
                </button>
              </div>
            } @else {
              <div class="question-tray__compare-item is-empty">
                <div class="question-tray__compare-empty">
                  <img src="assets/icn/products/quote.svg" class="icon" alt="" />
                  <p>Select another product</p>
                </div>
              </div>
            }
          }
        </div>
        <div class="question-tray__alt-compare-btn">
          <a href="#" class="button button--block button--lg button--primary" [class.button--disabled]="compareIds.length < maxCompare"
            (click)="openCompareModal($event)">Compare plans</a>
        </div>
      </div>
    </div>
  </footer>

  <!-- Compare modal -->
  <div class="modal fade modal--ds modal--lg" id="modal-compare" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <header class="modal-header">
          <div class="modal-nav">
            <div class="modal-nav__title">
              <h4>Compare</h4>
            </div>
            <div class="modal-nav__actions">
              <a href="#" class="button button--primary" [class.button--disabled]="comparePdfLoading" (click)="downloadComparePdf($event)">
                <span>Download PDF</span>
                <svg class="icon"><use xlink:href="#download"></use></svg>
              </a>
              <button type="button" class="icon-button icon-button--md icon-button--white" data-dismiss="modal" aria-label="Close">
                <svg class="icon"><use xlink:href="#close-circle-small"></use></svg>
              </button>
            </div>
          </div>
        </header>
        <div class="modal-body">
          <div class="modal-body-contain">
            @if (compareLoading) {
              <p class="text-center"><small>Loading the comparison...</small></p>
            } @else if (compareError) {
              <p class="text-center"><small>We couldn't load the comparison. <a href="#" (click)="loadCompare($event)"><strong>Retry</strong></a></small></p>
            } @else {
              <!-- Row counts are the section's rows plus its title row; the grid's repeat() needs at least 1, so an absent section keeps one empty row -->
              <div class="product-compare" [style.--feature-row-count]="compareFeatureRows.length ? compareFeatureRows.length + 1 : 1"
                [style.--included-row-count]="compareIncludedRows.length ? compareIncludedRows.length + 1 : 1" [style.--not-included-row-count]="compareNotIncludedRows.length ? compareNotIncludedRows.length + 1 : 1">
                @for (col of compareSlots; track $index; let c = $index) {
                  <div class="product-compare__card">
                    <div class="product-compare__selector">
                      <div class="dropdown dropdown--compare">
                        <div data-toggle="dropdown" aria-expanded="false" class="dropdown-toggle">
                          <div>
                            <img [src]="col?.img_path" class="img-fluid" [alt]="col?.product_name" />
                          </div>
                          <p>
                            <span><strong>{{col?.product_name}}</strong></span>
                            <small><strong>{{col?.premium}}</strong>/{{col?.frequency_short}}</small>
                          </p>
                          <svg class="icon"><use xlink:href="#chevron-down-smaller"></use></svg>
                        </div>
                        <div class="dropdown-menu">
                          @for (option of compareCandidates(c); track option.product_id) {
                            <a class="dropdown-item" [class.is-active]="option.product_id === col?.product_id" href="#"
                              (click)="selectCompareProduct(c, option.product_id, $event)">
                              <div>
                                <img [src]="option.img_path" class="img-fluid" [alt]="option.product_name" />
                              </div>
                              <p>
                                <span><strong>{{option.product_name}}</strong></span>
                                <small><strong>{{option.premium}}</strong>/{{option.frequency_short}}</small>
                              </p>
                            </a>
                          }
                        </div>
                      </div>
                    </div>
                    @if (compareFeatureRows.length) {
                      <div class="product-compare__category product-compare__category--features">
                        <div class="product-compare__title">
                          <span>Features</span>
                          @if (sectionTooltips['features']) {
                            <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                              data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['features']">
                              <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                            </a>
                          }
                        </div>
                        <div class="product-compare-details">
                          @for (row of compareFeatureRows; track row.entity_id) {
                            <div class="product-compare-details__item">
                              @if (row.cells[c]; as cell) {
                                <p>
                                  <span>{{row.label}}</span>
                                  @if (cell.tooltip) {
                                    <a class="popover-trigger popover-trigger--hover popover-trigger--sm popover-trigger--inline" tabindex="0"
                                      data-toggle="popover" data-trigger="focus" [attr.data-content]="cell.tooltip">
                                      <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                                    </a>
                                  }
                                  @if (cell.value) {
                                    <span class="nowrap"><strong>{{cell.value}}</strong></span>
                                  }
                                </p>
                              } @else {
                                <p class="text-color-secondary"><span>{{row.label}}</span>&nbsp;<svg class="icon icon--sm text-color-error" role="img" aria-label="Not included"><use xlink:href="#circle-small-excluded"></use></svg></p>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (compareIncludedRows.length || compareNotIncludedRows.length) {
                      <div class="product-compare__more seemore__expander collapse" [id]="'seemore-' + c">
                        @if (compareIncludedRows.length) {
                          <div class="product-compare__category product-compare__category--included">
                            <div class="product-compare__title">
                              <span>Included</span>
                              @if (sectionTooltips['included']) {
                                <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                  data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['included']">
                                  <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                                </a>
                              }
                            </div>
                            <div class="product-compare-details">
                              @for (row of compareIncludedRows; track row.key) {
                                <div class="product-compare-details__item">
                                  @if (row.cells[c]; as cell) {
                                    <p class="d-flex w-100">
                                      <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon" alt=""
                                        (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                                      <span class="flex-grow-1">
                                        <strong>{{row.label}}</strong>
                                        @if (cell.tooltip) {
                                          <a class="popover-trigger popover-trigger--hover popover-trigger--sm popover-trigger--inline" tabindex="0"
                                            data-toggle="popover" data-trigger="focus" [attr.data-content]="cell.tooltip">
                                            <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                                          </a>
                                        }
                                      </span>
                                      @if (cell.value === '-') {
                                        <svg class="icon text-color-personal ml-auto" aria-label="No limit"><use xlink:href="#circle-small-included"></use></svg>
                                      } @else if (cell.value) {
                                        <small class="text-color-secondary text-right nowrap ml-auto">{{cell.value}}</small>
                                      }
                                    </p>
                                  } @else {
                                    <p class="text-color-secondary d-flex w-100">
                                      <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon" alt=""
                                        (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                                      <span class="flex-grow-1"><strong>{{row.label}}</strong></span>
                                      <svg class="icon text-color-error ml-auto" role="img" aria-label="Not included"><use xlink:href="#circle-small-excluded"></use></svg>
                                    </p>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (compareNotIncludedRows.length) {
                          <div class="product-compare__category product-compare__category--not-included">
                            <div class="product-compare__title">
                              <span>Not included</span>
                              @if (sectionTooltips['not_included']) {
                                <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                  data-toggle="popover" data-trigger="focus" [attr.data-content]="sectionTooltips['not_included']">
                                  <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                                </a>
                              }
                            </div>
                            <div class="product-compare-details">
                              @for (row of compareNotIncludedRows; track row.key) {
                                <div class="product-compare-details__item">
                                  @if (row.cells[c]) {
                                    <p class="d-flex w-100">
                                      <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon" alt=""
                                        (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                                      <span class="flex-grow-1"><strong>{{row.label}}</strong></span>
                                      <svg class="icon text-color-error ml-auto" role="img" aria-label="Not included"><use xlink:href="#circle-small-excluded"></use></svg>
                                    </p>
                                  } @else {
                                    <p class="text-color-secondary d-flex w-100">
                                      <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon" alt=""
                                        (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                                      <span class="flex-grow-1"><strong>{{row.label}}</strong></span>
                                    </p>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                      <div class="product-compare__more-trigger">
                        <a href="#" class="button-control seemore collapsed" data-toggle="collapse" [attr.data-target]="'#seemore-' + c"
                          (click)="compareMoreOpen[c] = !compareMoreOpen[c]">
                          <svg class="icon icon--sm"><use xlink:href="#plus"></use></svg><svg class="icon icon--sm"><use xlink:href="#minus"></use></svg><strong>{{ compareMoreOpen[c] ? 'See less' : 'See more' }}</strong>
                        </a>
                      </div>
                    }
                  </div>
                }
              </div>
                <!-- In more detail -->
                <ng-template #dealHeader let-description="description">
                  <div class="compare-deal__header">
                    <div class="compare-deal__description">
                      @if (description) {
                        <h5 class="font-16 mb-10">{{description.title}}</h5>
                        <p>{{description.text}}</p>
                      }
                    </div>
                    <div class="compare-deal__options">
                      <ul class="compare-deal__options-toggler list-unstyled">
                        @for (col of compareSlots; track $index; let c = $index) {
                          <li [class.is-active]="compareDetailActive === c" (click)="compareDetailActive = c">{{col?.product_name}}</li>
                        }
                      </ul>
                      @for (col of compareSlots; track $index; let c = $index) {
                        <div class="compare-deal__options-col" [class.is-active]="compareDetailActive === c">
                          <div class="compare-deal-item">
                            <div class="compare-deal-item__thumb">
                              <img [src]="col?.img_path" class="img-fluid" [alt]="col?.product_name" />
                            </div>
                            <h4 class="compare-deal-item__title">{{col?.product_name}}</h4>
                            <div class="compare-deal-item__cost">
                              <p><strong>{{col?.premium}}</strong> /{{col?.frequency_short}}</p>
                            </div>
                          </div>
                          @if (col?.has_wording) {
                            <div class="text-center mt-20">
                              <a href="#" class="button-control button-control--tight" (click)="viewCompareWording(col, $event)">
                                <svg class="icon icon--sm"><use xlink:href="#modal"></use></svg><strong>View Wording</strong>
                              </a>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </ng-template>
                <div class="deal-compare">
                  <div class="deal-compare__title">
                    <h3>In more detail</h3>
                  </div>
                  <div class="deal-compare__accordion">
                    <div class="accordion accordion--cards" id="accordion-compare">
                      <div class="accordion__item">
                        <a href="#compare-items" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false" (click)="ensureCompareDetail()">
                          <div class="accordion__title-text"><h5>Your Insured Items</h5></div>
                          <div class="accordion__title-caret"><svg class="icon"><use xlink:href="#dropdown"></use></svg></div>
                        </a>
                        <div class="accordion__body collapse" id="compare-items" data-parent="#accordion-compare">
                          <div class="accordion__content">
                            <div class="compare-deal">
                              <ng-container *ngTemplateOutlet="dealHeader; context: { description: null }"></ng-container>
                              <div class="compare-deal__content">
                                <div class="compare-deal-data">
                                  @if (compareDetailLoading) {
                                    <p class="text-center"><small>Loading...</small></p>
                                  } @else if (compareDetailError) {
                                    <p class="text-center"><small>We couldn't load this. <a href="#" (click)="ensureCompareDetail($event)"><strong>Retry</strong></a></small></p>
                                  } @else if (!compareItemGroups.length) {
                                    <p class="text-center text-color-grey-6"><small>No insured items to compare.</small></p>
                                  } @else {
                                    @for (group of compareItemGroups; track group.group_id) {
                                      <div class="compare-deal-data__row compare-deal-data__row--th">
                                        <div class="compare-deal-data__colhead"><h5>{{group.group_name}}</h5></div>
                                        @for (cell of group.totalCells; track $index; let c = $index) {
                                          <div class="compare-deal-data__colitem" [class.is-active]="compareDetailActive === c">
                                            @if (cell) {
                                              <p><strong><em>{{cell.value}}</em>.00</strong> /{{compareSlots[c]?.frequency_short}}</p>
                                            }
                                          </div>
                                        }
                                      </div>
                                      @for (row of group.rows; track row.key) {
                                        <div class="compare-deal-data__row">
                                          <div class="compare-deal-data__colhead">
                                            <div>
                                              <p>{{row.title}}</p>
                                              @if (row.subtitle) {
                                                <p><small class="text-color-secondary">{{row.subtitle}}</small></p>
                                              }
                                            </div>
                                          </div>
                                          @for (cell of row.cells; track $index; let c = $index) {
                                            <div class="compare-deal-data__colitem" [class.is-active]="compareDetailActive === c">
                                              @if (cell) {
                                                <p><strong>{{cell.value}}.00</strong> /{{compareSlots[c]?.frequency_short}}</p>
                                                @if (row.more[c]) {
                                                  <span class="tag tag--more">{{row.more[c]}}</span>
                                                }
                                              }
                                            </div>
                                          }
                                        </div>
                                      }
                                    }
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#compare-insurers" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
                          <div class="accordion__title-text"><h5>The Insurers</h5></div>
                          <div class="accordion__title-caret"><svg class="icon"><use xlink:href="#dropdown"></use></svg></div>
                        </a>
                        <div class="accordion__body collapse" id="compare-insurers" data-parent="#accordion-compare">
                          <div class="accordion__content">
                            <div class="compare-deal">
                              <ng-container *ngTemplateOutlet="dealHeader; context: { description: { title: 'How ratings are calculated', text: 'This rating is based on whether an insurer is good or not in the areas our customers care about.' } }"></ng-container>
                              <div class="compare-deal__content">
                                <div class="compare-deal-data">
                                  <div class="compare-deal-data__row">
                                    <div class="compare-deal-data__colhead"><p>Insurer Name</p></div>
                                    @for (col of compareSlots; track $index; let c = $index) {
                                      <div class="compare-deal-data__colitem" [class.is-active]="compareDetailActive === c"><p>{{col?.insurer_name}}</p></div>
                                    }
                                  </div>
                                  <div class="compare-deal-data__row">
                                    <div class="compare-deal-data__colhead"><p>Overall Rating</p></div>
                                    @for (col of compareSlots; track $index; let c = $index) {
                                      <div class="compare-deal-data__colitem" [class.is-active]="compareDetailActive === c">
                                        <div class="d-flex">
                                          <div class="stars">
                                            @for (percent of starPercents(col); track $index) {
                                              <div class="stars__star">
                                                <svg class="icon"><use xlink:href="#star-inactive"></use></svg>
                                                <div class="stars__percent stars__percent--{{percent}}">
                                                  <svg class="icon"><use xlink:href="#star-active"></use></svg>
                                                </div>
                                              </div>
                                            }
                                          </div>
                                          <p class="nowrap font-semibold ml-10">{{getOverallRating(col?.insurer_rating) | number:'1.0-1'}} stars</p>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                  @for (rating of compareInsurerRatingRows; track rating.rating_type) {
                                    <div class="compare-deal-data__row">
                                      <div class="compare-deal-data__colhead"><p>{{rating.rating_type}}</p></div>
                                      @for (cell of rating.cells; track $index; let c = $index) {
                                        <div class="compare-deal-data__colitem" [class.is-active]="compareDetailActive === c">
                                          @if (cell) {
                                            <p>{{cell.rating_score}} / {{cell.rating_denom}}</p>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion__item">
                        <a href="#compare-benefits" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false" (click)="ensureCompareDetail()">
                          <div class="accordion__title-text"><h5>The Benefits</h5></div>
                          <div class="accordion__title-caret"><svg class="icon"><use xlink:href="#dropdown"></use></svg></div>
                        </a>
                        <div class="accordion__body collapse" id="compare-benefits" data-parent="#accordion-compare">
                          <div class="accordion__content">
                            <div class="compare-deal">
                              <ng-container *ngTemplateOutlet="dealHeader; context: { description: null }"></ng-container>
                              <div class="compare-deal__content">
                                <div class="compare-deal-data">
                                  @if (compareDetailLoading) {
                                    <p class="text-center"><small>Loading...</small></p>
                                  } @else if (compareDetailError) {
                                    <p class="text-center"><small>We couldn't load this. <a href="#" (click)="ensureCompareDetail($event)"><strong>Retry</strong></a></small></p>
                                  } @else if (!compareBenefitGroups.length) {
                                    <p class="text-center text-color-grey-6"><small>No benefits to compare.</small></p>
                                  } @else {
                                    <div class="accordion accordion--compare">
                                      @for (group of compareBenefitGroups; track group.group_id) {
                                        <div class="accordion__item">
                                          <div class="accordion__title"><div class="accordion__title-text"><h5>{{group.group_name}}</h5></div></div>
                                          <div class="accordion__body">
                                            @for (row of group.rows; track row.key) {
                                              <div class="compare-deal-data__row">
                                                <div class="compare-deal-data__colhead is-wide">
                                                  <img [src]="row.img_path || 'assets/icn/24px-generic.svg'" class="icon icon--md" alt=""
                                                    (error)="$any($event.target).src = 'assets/icn/24px-generic.svg'" />
                                                  <p>
                                                    {{row.label}}
                                                    @if (row.cells[0]?.tooltip || row.cells[1]?.tooltip) {
                                                      <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                                                        data-toggle="popover" data-trigger="focus" [attr.data-content]="row.cells[0]?.tooltip || row.cells[1]?.tooltip">
                                                        <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                                                      </a>
                                                    }
                                                  </p>
                                                </div>
                                                @for (cell of row.cells; track $index; let c = $index) {
                                                  <div class="compare-deal-data__colitem" [class.is-active]="compareDetailActive === c">
                                                    @if (!cell) {
                                                      <svg class="icon text-color-error" role="img" aria-label="Not included"><use xlink:href="#circle-small-excluded"></use></svg>
                                                    } @else if (cell.value === '-') {
                                                      <svg class="icon text-color-personal" role="img" aria-label="No limit"><use xlink:href="#circle-small-included"></use></svg>
                                                    } @else {
                                                      <p>{{cell.value}}</p>
                                                    }
                                                    @if (cell?.description === 'Optional') {
                                                      <span class="tag tag--more">Added</span>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      @if (compareHasCovers) {
                        <div class="accordion__item">
                          <a href="#compare-covered" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false" (click)="ensureCompareDetail()">
                            <div class="accordion__title-text"><h5>What's Covered</h5></div>
                            <div class="accordion__title-caret"><svg class="icon"><use xlink:href="#dropdown"></use></svg></div>
                          </a>
                          <div class="accordion__body collapse" id="compare-covered" data-parent="#accordion-compare">
                            <div class="accordion__content">
                              <div class="compare-deal">
                                <ng-container *ngTemplateOutlet="dealHeader; context: { description: null }"></ng-container>
                                <div class="compare-deal__content">
                                  <div class="compare-deal-data">
                                    @if (compareDetailLoading) {
                                      <p class="text-center"><small>Loading...</small></p>
                                    } @else if (compareDetailError) {
                                      <p class="text-center"><small>We couldn't load this. <a href="#" (click)="ensureCompareDetail($event)"><strong>Retry</strong></a></small></p>
                                    } @else if (!compareCoveredGroups.length) {
                                      <p class="text-center text-color-grey-6"><small>No statements to compare.</small></p>
                                    } @else {
                                      <div class="accordion accordion--compare">
                                        @for (group of compareCoveredGroups; track group.group_id) {
                                          <div class="accordion__item">
                                            <div class="accordion__title"><div class="accordion__title-text"><h5>{{group.group_name}}</h5></div></div>
                                            <div class="accordion__body">
                                              @for (row of group.rows; track row.key) {
                                                <div class="compare-deal-data__row">
                                                  <div class="compare-deal-data__colhead is-wide">
                                                    <div>
                                                      <h5 class="font-16">{{row.label}}</h5>
                                                      @if (row.description) {
                                                        <p class="font-normal text-color-grey-7 mt-10">{{row.description}}</p>
                                                      }
                                                    </div>
                                                  </div>
                                                  @for (cell of row.cells; track $index; let c = $index) {
                                                    <div class="compare-deal-data__colitem" [class.is-active]="compareDetailActive === c">
                                                      @if (cell) {
                                                        <svg class="icon text-color-personal" role="img" aria-label="Covered"><use xlink:href="#circle-small-included"></use></svg>
                                                      } @else {
                                                        <svg class="icon text-color-error" role="img" aria-label="Not covered"><use xlink:href="#circle-small-excluded"></use></svg>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      @if (compareHasCovers) {
                        <div class="accordion__item">
                          <a href="#compare-not-covered" class="accordion__title collapsed" data-toggle="collapse" aria-expanded="false" (click)="ensureCompareDetail()">
                            <div class="accordion__title-text"><h5>What's Not Covered</h5></div>
                            <div class="accordion__title-caret"><svg class="icon"><use xlink:href="#dropdown"></use></svg></div>
                          </a>
                          <div class="accordion__body collapse" id="compare-not-covered" data-parent="#accordion-compare">
                            <div class="accordion__content">
                              <div class="compare-deal">
                                <ng-container *ngTemplateOutlet="dealHeader; context: { description: null }"></ng-container>
                                <div class="compare-deal__content">
                                  <div class="compare-deal-data">
                                    @if (compareDetailLoading) {
                                      <p class="text-center"><small>Loading...</small></p>
                                    } @else if (compareDetailError) {
                                      <p class="text-center"><small>We couldn't load this. <a href="#" (click)="ensureCompareDetail($event)"><strong>Retry</strong></a></small></p>
                                    } @else if (!compareNotCoveredGroups.length) {
                                      <p class="text-center text-color-grey-6"><small>No statements to compare.</small></p>
                                    } @else {
                                      <div class="accordion accordion--compare">
                                        @for (group of compareNotCoveredGroups; track group.group_id) {
                                          <div class="accordion__item">
                                            <div class="accordion__title"><div class="accordion__title-text"><h5>{{group.group_name}}</h5></div></div>
                                            <div class="accordion__body">
                                              @for (row of group.rows; track row.key) {
                                                <div class="compare-deal-data__row">
                                                  <div class="compare-deal-data__colhead is-wide">
                                                    <div>
                                                      <h5 class="font-16">{{row.label}}</h5>
                                                      @if (row.description) {
                                                        <p class="font-normal text-color-grey-7 mt-10">{{row.description}}</p>
                                                      }
                                                    </div>
                                                  </div>
                                                  @for (cell of row.cells; track $index; let c = $index) {
                                                    <div class="compare-deal-data__colitem" [class.is-active]="compareDetailActive === c">
                                                      @if (cell?.value === 'Optional') {
                                                        <p class="text-color-grey-6">Optional</p>
                                                      } @else if (cell) {
                                                        <svg class="icon text-color-error" role="img" aria-label="Not covered"><use xlink:href="#circle-small-excluded"></use></svg>
                                                      } @else if (row.otherCells[c]) {
                                                        <svg class="icon text-color-personal" role="img" aria-label="Covered"><use xlink:href="#circle-small-included"></use></svg>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Compare modal -->
